import React, { useState } from "react";
import PrintOptions from "../PrintOptions";
import { ROUTES } from "../../utils/Routes";

export default function PrintOptionsWrapper(props) {

    const { controller = "", route = "", callback = () => { }, header } = props;

    const [rows, setRows] = useState([]);

    return (
        <div style={{ "width": "1000px" }}>
            <div className="shim" /><div className="shim" />
            <PrintOptions
                header={header}
                rows={rows}
                setRows={setRows}
                controller={controller}
                route={ROUTES.POS.PRINT}
                editRoute={ROUTES.POS.PRINT_EDIT}
                active={true}
                dismissOnFirstRowEscape
                onBack={() => {
                    callback(false);
                }}
                onComplete={(rows, printSettings) => {
                    callback({ rows, printSettings });
                }}
            />
        </div>
    )
}